import clsx from 'clsx';
import DropDownButton from 'devextreme-react/drop-down-button';
import React from 'react';
import { Link } from 'react-router-dom';
import { useCommonContext } from '../../contexts/common';
import styles from './PhuHuynhChildItem.module.css';
const PhuHuynhChildItem = ({ hocSinh, isSelected, onSelected, onDeleted }) => {
	const { translate } = useCommonContext();

	return (
		<div className={clsx(styles.container, isSelected ? styles.isSelected : '')}>
			<div className={styles.caption}>
				<div className={styles.name}>
					<Link to={`../../hoc-sinh/${hocSinh.id}`}>
						{hocSinh.ho_ten}
						<i className="fas fa-chevron-right"></i>
					</Link>
				</div>
				<DropDownButton
					text=''
					icon='overflow'
					dropDownOptions={{ width: 90 }}
					displayExpr='name'
					keyExpr='id'
					stylingMode='text'
					visible={true}
					items={[
						// { id: 1, name: 'Sửa', icon: 'edit' },
						{ id: 2, name: 'Xóa', icon: 'trash' },
					]}
					onItemClick={(e) => {
						// if (e.itemData.id == 1) onSelected();

						if (e.itemData.id == 2) onDeleted();
					}}
				/>
			</div>
			<p className={styles.info_container}>
				<span className={styles.tag}>{translate(hocSinh.trang_thai)}</span>
			</p>
			<div className={styles.info_container}>


				<p className={styles.info_container}>
					<i className='fas fa-tasks'></i>
					<>{hocSinh.ma_hs}</>
				</p>
				<p className={styles.info_container}>
					{hocSinh.dm_gioitinh_id == 1 && <i className='fas fa-male'></i>}
					{hocSinh.dm_gioitinh_id == 2 && <i className='fas fa-female'></i>}
					<>{hocSinh.gioi_tinh}</>
				</p>
			</div>
			<p className={styles.info_container}>
				<i className='fas fa-tasks'></i>
				<>{hocSinh.ten_he}</>
			</p>
			<p className={styles.info_container}>
				<i className='fas fa-door-open'></i>
				<>{hocSinh.ten_lop}</>
			</p>
		</div>
	);
};

export default PhuHuynhChildItem;
